/** Lobby “new UI” promo modal: show once per login; cleared whenever account/session is wiped. */
export const NEW_UI_LOBBY_MODAL_SEEN_KEY = "newUiLobbyModalSeen";

/** UUSLOT x EPICWIN promo modal: show once per login. After the new UI modal when that modal is shown; otherwise on the lobby. */
export const UUSLOT_PROMO_MODAL_SEEN_KEY = "uuslotPromoModalSeen";
